:host {
  --uui-header-background-color: var(--uui-theme-variant-800);
  --uui-header-height: 135px;
  --uui-header-logo-width: 90px;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  width: 80%;
}


.logo-container {
  width: var(--uui-header-logo-width);
}

.icon-container {
  margin-top: var(--uui-large-spacing);
  margin-bottom: var(--uui-large-spacing);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--uui-header-background-color);
  border-radius: 50%;
  width: 90px;
  height: 90px;
}

.header {
  height: var(--uui-header-height);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: var(--uui-header-background-color);
}

@media screen and (max-width: 320px) {
  :host {
    --uui-header-height: 100px;
    --uui-header-logo-width: 60px;
  }
}
